import {dealDownloadFileResponse} from "@/api/file";
import request from "@/utils/request";
// import {formatSourceDataFromSever} from "@/views/Operate/Content/style-xml-manager";
import {formatDateFromSeverDouble} from "@/utils/tools";
import {encrypt} from "@/utils/encrypt";


/**
 * 导出报告
 * @param userId
 * @param key
 * @returns {AxiosPromise}
 */
 export function ExportReport({userId,sDate='',eDate=''}) {
    return request({
        url: `/appi/Operate/ExportReport?uId=${encrypt(userId)}&sDate=${sDate}&eDate=${eDate}`,
        method: 'get',
        responseType: 'blob'
    }).then(res => {
        console.log(res);
        return dealDownloadFileResponse({res});
    })
}


/**
 * 获取终端用户列表
 * @param userId
 * @param key
 * @returns {AxiosPromise}
 */
export function getUserList({userId,sDate,eDate, key = ''}) {    
    return request({url: `/appi/Operate/getUserList?uId=${userId}&sDate=${sDate}&eDate=${eDate}&key=${key}`})
}


/**
 * 获取多种级联列表
 * @param userId
 * @param key
 * @returns {AxiosPromise}
 */
export function getCascadeList({userId,typeId=1}) {    
    return request({url: `/appi/Operate/GetCascadeList?uId=${userId}&typeId=${typeId}`})
}

/**
 * 获取多种级联列表
 * @param userId
 * @param key
 * @returns {AxiosPromise}
 */
 export function getAllMediaList({userId,typeId=1,stationIds='',key=''}) {    
    return request({url: `/appi/Operate/GetAllMediaList?uId=${userId}&typeId=${typeId}&stationIds=${stationIds}&key=${key}`})
}

